import { TableEditCompleteEvent } from 'primeng/table';
import { IItemCategoryEditBe, ItemCategory } from '../../models/inventory/item-category';

export const toItemCategory = (itemCategorySource: any[]): ItemCategory[] => {
	return itemCategorySource.map((c: any) => {
		return {
			categoryId: c.category_id,
			categoryName: c.category_name,
			desc: c.description,
			abbr: c.short_description
		};
	});
};

export const toItemCatBe = (itemCat: ItemCategory): any => {
	return {
		category_name: itemCat.categoryName,
		description: itemCat.desc,
		short_description: itemCat.abbr
	};
};

export const toEditedBe = (e: TableEditCompleteEvent): IItemCategoryEditBe => {
	const editedData: IItemCategoryEditBe = {};

	if (e.field === 'categoryName') {
		editedData.category_name = e.data;
	} else if (e.field === 'abbr') {
		editedData.short_description = e.data;
	}

	return editedData;
};

export const getIconAndTooltip = (field: string, value: string) => {
	const mappings: any = {
		location: {
			'@warehouse': { icon: 'pi pi-home', tooltip: 'at warehouse' },
			'@truck': { icon: 'pi pi-truck', tooltip: 'on the truck' },
			'@patient': { icon: 'pi pi-user', tooltip: 'with patient' },
			'@vendor': { icon: 'pi pi-briefcase', tooltip: 'with vendor' }
		},
		usageStatus: {
			'available': { icon: 'pi pi-check', tooltip: 'available' },
			'not available': { icon: 'pi pi-times', tooltip: 'not available' }
		}
		//   purchaseStatus: {
		//     'requested': { icon: 'pi pi-file', tooltip: 'requested'},
		//     'pending receive': { icon: 'pi pi-clock', tooltip: 'pending receive'},
		//     'received': { icon: 'pi pi-clock', tooltip: 'received'},
		//   }
	};

	return mappings[field][value] || { icon: 'pi pi-question', tooltip: 'Unknown' };
};
